// Fix this file, do not use any as the type
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useMemo } from 'react'
import { useSelector, shallowEqual } from 'react-redux'

/**
 * THIS METHOD SHOULD BE DEPRECATED AND NOT USE ANYMORE
 * @param {*} authoritiessList
 * @param {*} allowedList
 * @returns {boolean}
 */
const useAllowedAccessFor = (authoritiessList: any[] = [], allowedList: any[] = []) =>
  /** *****
   *  EXAMPLE AUTHORITIES
   *  @authoritiessList = [{"name": "AUTH_PRICING" },{ "name": "AUTH_SUPPLY_CHAIN" }]]
   *
   *  EXAMPLE ALLOWEDLIST
   *  @allowedList = ['AUTH_MERCHANDISING_ADMIN','AUTH_MERCHANDISING_HUB', 'AUTH_MERCHANDISING_WAREHOUSE' ]
   *
   */

  useMemo(() => {
    const findAllowedAccess = (arr1: any[], arr2: any[]) =>
      arr1.some((item) => arr2?.includes(item))

    const currentUserAuth = authoritiessList?.map((items: any) => items.name)

    /** *
     *  RETURN TRUE IF ROLES IS EXIST
     *
     *  MAKE AUTH_ADMIN as Default allowed accesss
     */
    return findAllowedAccess(currentUserAuth, ['AUTH_ADMIN', ...allowedList])
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authoritiessList])

/**
 * THIS METHOD SHOULD BE DEPRECATED AND NOT USE ANYMORE
 * @param {*} authoritiessList
 * @param {*} allowedList
 * @returns {boolean}
 */
export const useBlockedAccessFor = (authoritiessList: any[] = [], blockedList: any[] = []) =>
  /** *****
   *  EXAMPLE AUTHORITIES
   *  @authoritiessList = [{"name": "AUTH_PRICING" },{ "name": "AUTH_SUPPLY_CHAIN" }]]
   *
   *  EXAMPLE ALLOWEDLIST
   *  @allowedList = ['AUTH_MERCHANDISING_ADMIN','AUTH_MERCHANDISING_HUB', 'AUTH_MERCHANDISING_WAREHOUSE' ]
   *
   */

  useMemo(() => {
    const findAllowedAccess = (arr1: any[], arr2: any[]) =>
      arr1.some((item) => arr2?.includes(item))

    const currentUserAuth = authoritiessList?.map((items: any) => items.name)

    /** *
     *  RETURN TRUE IF ROLES IS EXIST
     *
     *  MAKE AUTH_ADMIN as Default allowed accesss
     */
    return findAllowedAccess(currentUserAuth, [...blockedList])
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authoritiessList])

export const useViewOnly = (viewOnlyList: any[] = []) => {
  const authorities = useSelector(
    ({ auth: { userData } }: any) => userData.authorities,
    shallowEqual,
  )

  return useMemo(() => {
    const findAllowedAccess = (arr1: any[], arr2: any[]) =>
      arr1.some((item) => arr2?.includes(item))

    const currentUserAuth = authorities?.map((items: any) => items.name)

    return findAllowedAccess(currentUserAuth, [...viewOnlyList])
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authorities])
}

/**
 * This useAllowedAccess hooks basically have same implementation with useAllowedAccessFor.
 * The difference is just user authorities loaded directly from store instead from argument.
 * @param {*} allowedList
 * @returns
 */
export const useAllowedAccess = (allowedList: any[] = []) => {
  const authorities = useSelector(
    ({ auth: { userData } }: any) => userData.authorities,
    shallowEqual,
  )

  return useMemo(() => {
    const findAllowedAccess = (arr1: any[], arr2: any[]) =>
      arr1.some((item) => arr2?.includes(item))

    const currentUserAuth = authorities?.map((items: any) => items.name)

    return findAllowedAccess(currentUserAuth, ['AUTH_ADMIN', ...allowedList])
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authorities])
}

export default useAllowedAccessFor
